<div fxLayout="column">
    <br>
    <div *ngIf="hasValue" class="container">
        <mat-table class="table-list" [dataSource]="pagedData" multiTemplateDataRows>
            <ng-container matColumnDef="mcc" class="table-list__column-large">
                <mat-header-cell *matHeaderCellDef [ngClass]="'header-name'"> MCC</mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="'column-name'"> {{element.mcc}}
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"></mat-row>
         <ng-container matColumnDef="mccDescription" class="table-list__column">
                <mat-header-cell *matHeaderCellDef> Ramo de Atividade</mat-header-cell>
                <mat-cell *matCellDef="let element" >
                    {{applyFormatRefexFilterMccDescription(element.mccDescription)}} 
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="createdDate" class="table-list__column">
                <mat-header-cell *matHeaderCellDef> Data Criação</mat-header-cell>
                <mat-cell *matCellDef="let element" >
                    {{element.createdDate |  date: 'dd/MM/yyyy' }} 
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="options_edit">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let element" class="options">
                     <ng-container >
                        <fa-icon class="edit-link" matTooltip="Historico" icon="file" (click)="detail(element)">
                        </fa-icon>
                    </ng-container>
                    <ng-container *ngIf="hasWriteAccess">
                        <fa-icon class="detail" matTooltip="Excluir Mcc da lista" icon="trash"
                            (click)="delete(element)"></fa-icon>
                    </ng-container>
                </mat-cell>
            </ng-container>
        </mat-table>

        <mat-paginator
            [pageSizeOptions]="[defaultSizeItems,defaultSizeItems*2,defaultSizeItems*3,defaultSizeItems*4,defaultSizeItems*5,defaultSizeItems*6,defaultSizeItems*7,defaultSizeItems*8,defaultSizeItems*9,defaultSizeItems*10]"
            [length]="totalItens"
            [pageIndex]="currentPageIndex"
            [pageSize]="currentPageSize"
            (page)="change($event)">
        </mat-paginator>
    </div>

    <h5 *ngIf="!hasValue">Nenhum registro foi encontrado</h5>
</div>
